<template>
  <v-card>
    <v-system-bar dark window color="info">
      <v-icon center>mdi-information</v-icon>
      <v-toolbar-title class="ml-1">Информация о {{type==='monitor' ? "мониторе" : "статистике"}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small icon @click.native="$emit('close-dialog')">
        <v-icon class="mx-0">clear</v-icon>
      </v-btn>
    </v-system-bar>
    
    <v-card-text class="pt-1">
      <h3 class="my-2 title">{{statistic.name}}</h3>
      <p class="body-2" v-if="owner">Владелец: {{owner}}</p>
      <div v-html="statistic.description"></div>
      <statistic-select v-model="graphs" v-if="type==='monitor'"></statistic-select>
      
    </v-card-text>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  import {mapGetters} from 'vuex'
  import StatisticSelect from '../../Common/StatisticSelect'
  
  export default {
    name : "InfoForm",
  
    mixins: [entities],
    
    components:{
      StatisticSelect
    },
    
    props: {
      id: {
        type: Number,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
  
    computed:{
      ...mapGetters('app/org', ['getPostById']),
    },
    
    data(){
      return {
        statistic: {},
        graphs: [],
        owner: null
      }
    },
    
    created(){
      switch(this.type){
        case 'setting':
          this.$store.dispatch('analytics/statistics/statisticInfo', this.id).then( statistic => {
            this.statistic = statistic
          })
          break
        case 'graph':
          this.$store.dispatch('analytics/statistics/getGraph', this.id).then( statistic => {
            this.statistic = statistic
            let post = this.getPostById(this.statistic.owner_id)
            if(post.loaded){
              this.owner = `${post.name} (${post.fullname})`
            } else{
              this.$store.dispatch('app/org/entitiesInfo', { posts: [this.statistic.owner_id], containers: [] }).then( response => {
                if(response.posts_data[0]){
                  this.$store.commit('app/org/addPosts', response.posts_data)
                  this.owner = `${response.posts_data[0].name} (${response.posts_data[0].fullname})`
                } else {
                  this.owner = 'Неизвестный пост'
                }
              })
            }
          })
          break
        case 'monitor':
          this.$store.dispatch('analytics/statistics/getMonitor', this.id).then( statistic => {
            this.statistic = statistic
            let post = this.getPostById(this.statistic.owner_id)
            if(post.loaded){
              this.owner = `${post.name} (${post.fullname})`
            } else{
              this.$store.dispatch('app/org/entitiesInfo', { posts: [this.statistic.owner_id], containers: [] }).then( response => {
                if(response.posts_data[0]){
                  this.$store.commit('app/org/addPosts', response.posts_data)
                  this.owner = `${response.posts_data[0].name} (${response.posts_data[0].fullname})`
                } else {
                  this.owner = 'Неизвестный пост'
                }
              })
            }
            this.$store.dispatch( 'analytics/statistics/getMonitorGraphs', this.id ).then( graphs => {
              this.graphs = graphs
              this.graphs.map( setting => {
                this.convertOutputSettings(setting.lines)
              })
            })
          })
          break
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Forms/InfoForm.vue